import React, { useContext } from "react";
import { Grid } from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import { FormControl } from "../../../../common/components/libs";
import { observer } from "mobx-react";
import { SnackbarType } from "../../../../stores/common";
import { useStores } from "../../../../hooks";
import OrdersStoreContext from "./store/context";
import {useTranslation} from "react-i18next";


const TimePicker = () => {
    const {generalStore} = useStores()
    const ordersStore = useContext(OrdersStoreContext);
    const filter = ordersStore.filter;
    const {t} = useTranslation(["general"]);


    return <>
        <div>
            <Grid container spacing={4}
                  style={{
                      maxWidth: 500,
                      marginTop: 5
                  }}>
                <Grid item md={6} xs={6} lg={6}>
                    <FormControl>
                        <DatePicker
                            label={t("general:from")}
                            value={filter.createdAfter}
                            onChange={(value: Date) => {

                                ordersStore.setOrdersFilter({
                                    ...filter,
                                 createdAfter: value,
                                });
                                ordersStore.reloadOrders();
                                generalStore.showSnackbar({
                                     type: SnackbarType.success,
                                     title: t("general:labelOfUpdating")
                                 })
                            }}
                            // TODO: add text for another lang
                            okLabel={'Ок'}
                            cancelLabel={'Отменить'}
                        />
                    </FormControl>
                </Grid>

                <Grid item md={6} xs={6} lg={6}>
                    <FormControl>
                        <DatePicker
                            label={t("general:to")}
                            value={filter.createdBefore}
                            onChange={(value: Date) => {

                                ordersStore.setOrdersFilter({
                                            ...filter,
                                         createdBefore: value,
                                        });
                                        ordersStore.reloadOrders();
                                        generalStore.showSnackbar({
                                            type: SnackbarType.success,
                                            title: t("general:labelOfUpdating")
                                        })
                            }}
                        />
                    </FormControl>
                </Grid>
            </Grid>
        </div>
    </>
};


export default observer(TimePicker)
